<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <div
      [ngClass]="
        isPatientActive ? 'patient-name' : 'patient-name name-not-active'
      "
    >
      <h2>
        {{ patientForm.get("first_name")?.value }}
        {{ patientForm.get("last_name")?.value }}
      </h2>
    </div>
    <section class="registry-page">
      <header class="header">
        <h2>{{ labelService.getLabel("registry") }}</h2>
        <div class="header-buttons">
          @if (!isEditing) {
            <app-button [icon]="'edit'" (click)="onEditClick()"></app-button>
          }

          @if (isEditing) {
            <app-button
              [icon]="'delete'"
              (click)="onCancelClick()"
            ></app-button>
          }
          @if (isEditing) {
            <app-button [icon]="'save'" (click)="onSaveClick()"></app-button>
          }
        </div>
      </header>

      <form [formGroup]="patientForm" class="registry-form">
        <div class="form-row">
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("first_name") }}</mat-label>
            <input
              matInput
              formControlName="first_name"
              [readonly]="!isEditing"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("last_name") }}</mat-label>
            <input
              matInput
              formControlName="last_name"
              [readonly]="!isEditing"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("mobile") }}</mat-label>
            <input matInput formControlName="mobile" [readonly]="!isEditing" />
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("email") }}</mat-label>
            <input matInput formControlName="email" [readonly]="!isEditing" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("date_of_birth") }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="date_of_birth"
              [readonly]="!isEditing"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
              [disabled]="!isEditing"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("place_of_birth") }}</mat-label>
            <input
              matInput
              formControlName="place_of_birth"
              [readonly]="!isEditing"
            />
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field>
            <mat-label>{{
              labelService.getLabel("province_of_birth")
            }}</mat-label>
            <input
              matInput
              formControlName="province_of_birth"
              [readonly]="!isEditing"
            />
            @if (patientForm.get("province_of_birth")?.hasError("pattern")) {
              <mat-error>
                If provided, province of birth must be exactly 2 uppercase
                letters
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{
              labelService.getLabel("country_of_birth")
            }}</mat-label>
            <input
              matInput
              formControlName="country_of_birth"
              [readonly]="!isEditing"
            />
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("gender") }}</mat-label>
            <input matInput formControlName="gender" [readonly]="!isEditing" />
            @if (patientForm.get("gender")?.hasError("pattern")) {
              <mat-error>
                If provided, gender must be either 'M' or 'F'
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field>
            <mat-label>{{ labelService.getLabel("tax_code") }}</mat-label>
            <input
              matInput
              formControlName="tax_code"
              [readonly]="!isEditing"
            />
          </mat-form-field>
        </div>
      </form>
    </section>
  </main>
</app-side-top-bar>
